import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { HelpCircle, Mail, Info, Upload, Send, Megaphone, Tag, FolderTree, Settings } from 'lucide-react';

export default function Help() {
  const version = "1.0.0";

  const faqs = [
    {
      question: "Ürün nasıl yüklenir?",
      answer: "Ürün Yükleme sayfasına gidin, Excel dosyanızı ve ürün görsellerinizi (fotoğraf/video) seçin. Dosya isimleri ürün barkodu ile aynı olmalı (örn: 8690200075575.jpg). Yükle butonuna tıklayın ve ardından Yayınla ile Telegram kanallarınıza gönderin."
    },
    {
      question: "Markalar ve kategoriler nasıl eklenir?",
      answer: "Sol menüden Markalar veya Kategoriler sayfasına gidin. Yeni Ekle butonuna tıklayın, marka/kategori bilgilerini doldurun ve kaydedin. Her marka ve kategoriye özel Telegram kanal ID'si ekleyebilirsiniz."
    },
    {
      question: "Menü nasıl gönderilir?",
      answer: "Menü Gönder sayfasından manuel olarak gönderebilirsiniz. Menü gönderimi yapmadan önce bot token ve kanal ID'nin doğru ayarlandığından emin olun. Botun kanalınızda yönetici yetkisine sahip olduğundan emin olun. Menü, kanalınıza üç ayrı mesaj olarak gönderilecektir: Menü Butonları, Markalar ve Kategoriler. Ayrıca Ayarlar sayfasından otomatik menü gönderimini aktif ederseniz, her sabah 09:30'da otomatik olarak gönderilir."
    },
    {
      question: "Ürün etiketlerini nasıl değiştiririm?",
      answer: "Ürün Etiketleri sayfasından Product Code, Category, Color gibi etiketleri istediğiniz dile çevirebilirsiniz. Değişiklikler yeni ürün yüklemelerinde geçerli olur."
    },
    {
      question: "Otomatik menü gönderimi nasıl çalışır?",
      answer: "Ayarlar > Otomatik Menü Gönderimi bölümünden aktif edebilirsiniz. Her gün belirlediğiniz saatte (varsayılan 09:30) menü otomatik olarak ana kanalınıza gönderilir."
    },
    {
      question: "Birden fazla mağaza yönetebilir miyim?",
      answer: "Evet! Mağazalar sayfasından yeni mağaza oluşturabilir ve üst menüden mağazalar arasında geçiş yapabilirsiniz."
    },
    {
      question: "Telegram bot token'ı nasıl alınır?",
      answer: "Telegram'da @BotFather ile görüşün, /newbot komutu ile yeni bot oluşturun. Size verilen token'ı Ayarlar sayfasında Bot Token alanına yapıştırın."
    },
    {
      question: "Kanal ID'sini nasıl bulurum?",
      answer: "Botunuzu kanalınıza admin olarak ekleyin. @userinfobot'u kanalınıza ekleyin, kanal ID'sini gösterecektir (örn: -1001234567890)."
    }
  ];

  const usageSteps = [
    {
      icon: Settings,
      title: "1. Başlangıç Ayarları",
      description: "Önce Mağazalar sayfasından mağazanızı oluşturun ve Bot Token ile Ana Kanal ID'sini girin."
    },
    {
      icon: Tag,
      title: "2. Marka ve Kategoriler",
      description: "Markalar ve Kategoriler sayfalarından ürünlerinizin marka ve kategorilerini ekleyin. Her birine özel kanal ID'si atayabilirsiniz."
    },
    {
      icon: Upload,
      title: "3. Ürün Yükleme",
      description: "Excel dosyanızı ve ürün görsellerinizi hazırlayın. Dosya isimleri barkod numarası ile aynı olmalı. Ürün Yükleme sayfasından yükleyip yayınlayın."
    },
    {
      icon: Send,
      title: "4. Menü Gönderimi",
      description: "Menü Butonları sayfasından menü düğmelerinizi oluşturun. Menü Gönder ile manuel, veya Ayarlar'dan otomatik menü gönderimini aktif edin."
    },
    {
      icon: Megaphone,
      title: "5. Duyurular",
      description: "Duyuru Yap sayfasından müşterilerinize özel duyurular ve kampanya mesajları gönderin."
    }
  ];

  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <div className="mb-6 sm:mb-8">
        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-1 sm:mb-2 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
          Yardım & Destek
        </h1>
        <p className="text-sm sm:text-base text-gray-600">TeleBiz platformunu kullanmaya başlayın</p>
      </div>

      <div className="max-w-5xl mx-auto space-y-6">
        {/* Kullanım Kılavuzu */}
        <Card className="shadow-lg border-0 rounded-2xl overflow-hidden">
          <CardHeader className="bg-gradient-to-r from-purple-500 to-pink-500 text-white">
            <CardTitle className="text-lg sm:text-xl flex items-center">
              <Info className="w-5 h-5 sm:w-6 sm:h-6 mr-2" />
              Hızlı Başlangıç Kılavuzu
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-6">
            <div className="space-y-6">
              {usageSteps.map((step, index) => (
                <div key={index} className="flex gap-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 flex items-center justify-center">
                      <step.icon className="w-6 h-6 text-white" />
                    </div>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">{step.title}</h3>
                    <p className="text-sm text-gray-600">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* SSS */}
        <Card className="shadow-lg border-0 rounded-2xl overflow-hidden">
          <CardHeader className="bg-gradient-to-r from-blue-500 to-cyan-500 text-white">
            <CardTitle className="text-lg sm:text-xl flex items-center">
              <HelpCircle className="w-5 h-5 sm:w-6 sm:h-6 mr-2" />
              Sık Sorulan Sorular
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-6">
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div key={index} className="border-l-4 border-purple-500 pl-4 py-2 rounded-r-xl bg-gradient-to-r from-purple-50 to-transparent">
                  <h3 className="font-semibold text-gray-900 mb-2">{faq.question}</h3>
                  <p className="text-sm text-gray-600">{faq.answer}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>

        {/* İletişim */}
        <Card className="shadow-lg border-0 rounded-2xl overflow-hidden">
          <CardHeader className="bg-gradient-to-r from-green-500 to-emerald-500 text-white">
            <CardTitle className="text-lg sm:text-xl flex items-center">
              <Mail className="w-5 h-5 sm:w-6 sm:h-6 mr-2" />
              İletişim & Destek
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-6">
            <div className="space-y-4">
              <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-4 rounded-2xl">
                <p className="text-sm text-gray-700 mb-3">
                  Herhangi bir sorun yaşıyorsanız veya öneriniz varsa bizimle iletişime geçebilirsiniz:
                </p>
                <a 
                  href="mailto:team@hmaminal.com" 
                  className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-green-500 to-emerald-500 text-white rounded-2xl hover:from-green-600 hover:to-emerald-600 transition-all"
                >
                  <Mail className="w-4 h-4" />
                  team@hmaminal.com
                </a>
              </div>
              
              <div className="pt-4 border-t border-gray-200">
                <p className="text-xs text-gray-500 text-center">
                  TeleBiz Platform - Versiyon {version}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
